import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { from, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ApiErrorTrace, ErrorTraceService } from 'src/app/shared/services/error-trace.service';

@Component({
  selector: 'app-failure-modal',
  templateUrl: './failure-modal.component.html',
  styleUrls: ['./failure-modal.component.scss']
})

export class FailureModalComponent implements OnInit {
  showErrorDetails: any;
  isUUIDCopied: boolean = false;

  constructor(
    private translateService: TranslateService,
    private errorTraceService: ErrorTraceService
  ) { }

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  timeDelay = 10000;

   @Input()
  modalButtonVal = this.translateService.instant('COMMON.CommonCpifailedpopupButton_Close', {Default: 'Close'});

  autoClose: boolean = true;
  remainingSeconds = this.timeDelay / 1000;
  intervalId!: any;
  isTimerEnabled: boolean = true;
  errorTrace: ApiErrorTrace | null = null;
  copyStatus = '';



  @Output() closeSuccessModalDialogEvent = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.errorTrace = this.errorTraceService.getLastErrorTrace();

    const myArray = [1, 2, 3, 4];
    from(myArray).pipe(
      concatMap(item => of(item).pipe(delay(this.timeDelay)))
    ).subscribe(timedItem => {
      if(this.autoClose){
        this.closeModal();
      }
    });

     this.intervalId = setInterval(() => {
    this.remainingSeconds--;
      if (this.remainingSeconds === 0) {
        clearInterval(this.intervalId);
      }
    }, 1000);

  }

  raiseModalEvent(eventAction: string) {
    if (eventAction === 'close') {
      this.closeModal();
    }
  }

  onClose(action: string){
    if (action === 'close') {
        this.autoClose = true;
        this.closeModal();
    }
  }

  private closeModal(): void {
    this.errorTraceService.clear();
    this.errorTrace = null;
    this.showErrorDetails = false;
    this.closeSuccessModalDialogEvent.emit(true);
  }

  cancelAutoClose(){
    this.isTimerEnabled = false;
    this.autoClose = false;
  }
  get timeDelayInSeconds(): number {
    return this.timeDelay / 1000;
  }

  copyUUID(): void {
    if (!this.errorTrace) {
      this.copyStatus = 'No trace data available.';
      return;
    }

    const textToCopy = this.errorTrace.uuid || '';
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.copyStatus = 'Copied';
          this.isUUIDCopied = true;
          setTimeout(() => {
            this.copyStatus = '';
          }, 2000);
        })
        .catch(() => {
          this.copyStatus = 'Copy failed';
          this.isUUIDCopied = false;
          setTimeout(() => {
            this.copyStatus = '';
          }, 2000);
        });
      return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      this.copyStatus = 'Copied';
      this.isUUIDCopied = true;
      setTimeout(() => {
        this.copyStatus = '';
      }, 2000);
    } catch {
      this.copyStatus = 'Copy failed';
      this.isUUIDCopied = false;
    }
    document.body.removeChild(textArea);

  }

  ViewMore(){
    this.showErrorDetails = !this.showErrorDetails;
  }

  showLess(){
    this.showErrorDetails = !this.showErrorDetails;
  }

  //Copy complete error log - currently copying only UUID, can be enhanced to copy more details if required in future.

  copyErrorTrace(): void {
    if (!this.errorTrace) {
      this.copyStatus = 'No trace data available.';
      return;
    }

    const tracePayload = {
      uuid: this.errorTrace.uuid,
      url: this.errorTrace.url,
      method: this.errorTrace.method,
      requestPayload: JSON.parse(this.errorTrace.requestPayload || '{}'),
      response: this.errorTrace.response,
      timestamp: this.errorTrace.timestamp
    };

    const textToCopy = JSON.stringify(tracePayload, null, 2);
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.copyStatus = 'Copied';
          setTimeout(() => {
              this.copyStatus =   '';
            }, 2000);
        })
        .catch(() => {
          this.copyStatus = 'Copy failed';
        });
      return;
    }

    // Fallback for older browsers.
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      this.copyStatus = 'Copied';
    } catch {
      this.copyStatus = 'Copy failed';
    }
    document.body.removeChild(textArea);
  }
}
